"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTrue = exports.CookieProvider = exports.CookieContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _webVitals = require("web-vitals");
var _utils = require("../pwa-kit/utils/utils");
var _useConfig = require("../hooks/useConfig");
var _TagManager = _interopRequireDefault(require("../utils/TagManager"));
var _pwaKit = require("../pwa-kit");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CONSENTS = {
  c51: 'required',
  c52: 'marketing',
  c53: 'functional',
  c54: 'performance',
  '755': 'google_advertising_products',
  s1: 'google_ads',
  s7: 'facebook',
  s26: 'google_analytics',
  s135: 'google_general',
  s291: 'salesforce',
  s905: 'google_tag_manager',
  s1104: 'google_maps',
  s1432: 'trusted_shops_gmbh',
  s2536: 'tiktok_embed',
  s2631: 'microsoft_clarity',
  s3009: 'tiktok_analytics'
};
const CookieContext = exports.CookieContext = /*#__PURE__*/(0, _react.createContext)({
  isModalOpen: false,
  showDetails: false,
  setCookiesAllowed: () => {},
  openConsentBanner: () => {},
  eventTracking: () => {},
  getCookieAllowedById: () => false,
  isCMPReady: false
});
const isTrue = val => {
  return typeof val === 'boolean' ? val === true : val === 'true';
};
exports.isTrue = isTrue;
const sendEvents = (...events) => {
  // @ts-ignore
  const dataLayer = window.dataLayer || [];
  if (events[0] && events[0].ecommerce) {
    // @ts-ignore
    dataLayer.push({
      ecommerce: null
    });
  }
  dataLayer.push(...events);
  // @ts-ignore
  window.dataLayer = dataLayer;
};
const buildInitialConsents = () => {
  const initialConsents = {};
  Object.keys(CONSENTS).forEach(key => {
    initialConsents[key] = false;
  });
  return initialConsents;
};
const CookieProvider = ({
  children,
  gtmId
}) => {
  const {
    gtmDomain
  } = (0, _useConfig.useConfig)();
  const {
    updateDnt
  } = (0, _pwaKit.useDNT)();
  const [isCookieModalOpen, setCookieModalOpen] = (0, _react.useState)(false);
  const [isDetailsOpen, setIsDetailsOpen] = (0, _react.useState)(false);
  const [isCMPReady, setIsCMPReady] = (0, _react.useState)(false);
  const [consentsAllowed, setConsentsAllowed] = (0, _react.useState)(() => buildInitialConsents());
  const initializeTracker = () => {
    _TagManager.default.initialize({
      gtmId: gtmId,
      dataLayer: {
        originalLocation: `${location.protocol}//${location.hostname}${location.pathname}${location.search}`
      },
      domain: gtmDomain
    });
  };
  const pushToDataLayer = data => {
    _TagManager.default.dataLayer({
      dataLayer: {
        event: 'coreWebVitals',
        webVitalsMeasurement: {
          name: data === null || data === void 0 ? void 0 : data.name,
          id: data === null || data === void 0 ? void 0 : data.id,
          value: data === null || data === void 0 ? void 0 : data.value,
          delta: data === null || data === void 0 ? void 0 : data.delta,
          valueRounded: Math.round(data === null || data === void 0 ? void 0 : data.value),
          deltaRounded: Math.round(data === null || data === void 0 ? void 0 : data.delta)
        }
      }
    });
  };
  const initializeWebVitals = () => {
    (0, _webVitals.onCLS)(pushToDataLayer);
    (0, _webVitals.onFID)(pushToDataLayer);
    (0, _webVitals.onLCP)(pushToDataLayer);
  };
  const isCMPLoaded = () => {
    return !_utils.isServer && typeof window !== 'undefined' && typeof window.__cmp === 'function';
  };
  const getUpdatedConsents = data => {
    const updatedConsents = _objectSpread({}, consentsAllowed);
    Object.keys(updatedConsents).forEach(key => {
      if (data.hasOwnProperty(key)) {
        updatedConsents[key] = data[key] === true;
      } else {
        updatedConsents[key] = false;
      }
    });
    return updatedConsents;
  };
  const getCookieAllowedById = id => {
    return consentsAllowed[id] === true;
  };
  const setPurposeConsents = data => {
    const updatedConsents = getUpdatedConsents(data);
    const hasChanged = Object.keys(updatedConsents).some(key => updatedConsents[key] !== consentsAllowed[key]);
    if (hasChanged) {
      setConsentsAllowed(updatedConsents);
    }
    const marketing = updatedConsents['c52']; // CONSENTS['c52'] = 'marketing'
    updateDnt(!marketing);
  };
  const loadCMPConsent = () => {
    try {
      var _window$__cmp, _window;
      const data = (_window$__cmp = (_window = window).__cmp) === null || _window$__cmp === void 0 ? void 0 : _window$__cmp.call(_window, 'consentStatus');
      if (data !== null && data !== void 0 && data.userChoiceExists) {
        var _window$__cmp2, _window2;
        const consentGiven = (_window$__cmp2 = (_window2 = window).__cmp) === null || _window$__cmp2 === void 0 ? void 0 : _window$__cmp2.call(_window2, 'getCMPData');
        if (consentGiven) {
          const combinedConsents = _objectSpread(_objectSpread({}, consentGiven.purposeConsents), consentGiven.vendorConsents);
          setPurposeConsents(combinedConsents);
        }
      }
    } catch (error) {}
  };
  const onConsent = (0, _react.useMemo)(() => (0, _debounce.default)(event => {
    try {
      var _window$__cmp3, _window3;
      const data = (_window$__cmp3 = (_window3 = window).__cmp) === null || _window$__cmp3 === void 0 ? void 0 : _window$__cmp3.call(_window3, 'getCMPData');
      if (data) {
        const combinedConsents = _objectSpread(_objectSpread({}, data.purposeConsents), data.vendorConsents);
        setPurposeConsents(combinedConsents);
      }
    } catch (error) {}
  }, 500), []);
  (0, _react.useEffect)(() => {
    initializeTracker();
    initializeWebVitals();
    const waitForCMP = () => {
      if (isCMPLoaded()) {
        try {
          setIsCMPReady(true);
          loadCMPConsent();
          window.__cmp('addEventListener', ['consent', onConsent, false], null);
        } catch (e) {
          setTimeout(waitForCMP, 100);
        }
      } else {
        setTimeout(waitForCMP, 100);
      }
    };
    waitForCMP();
    return () => {
      var _window$__cmp4, _window4;
      (_window$__cmp4 = (_window4 = window).__cmp) === null || _window$__cmp4 === void 0 ? void 0 : _window$__cmp4.call(_window4, 'removeEventListener', ['consent', onConsent, false], null);
    };
  }, []);
  const setCookiesAllowed = values => {
    if (!isCMPReady) return;
    let options = [];
    if (typeof values === 'string') {
      options = values.split(',').map(option => option.trim());
      if (options.includes('accept_all')) {
        window.cmp_noscreen = true;
        setConsentAcceptAll();
      } else if (options.includes('reject_all')) {
        setConsentRejectAll();
      } else {
        if (options.includes('c51')) {
          window.cmp_noscreen = true;
        }
        Object.keys(CONSENTS).forEach(key => {
          const accepted = options.includes(key);
          setConsentById(key, accepted);
        });
      }
    }
  };
  const setConsentById = (id, val = false) => {
    if (!isCMPReady) return;
    if (id.startsWith('c')) {
      window.__cmp('setPurposeConsent', [id, val ? 1 : 0]);
    } else {
      window.__cmp('setVendorConsent', [id, val ? 1 : 0]);
    }
  };
  const setConsentAcceptAll = () => {
    if (!isCMPReady) return;
    window.__cmp('setConsent', 1);
  };
  const setConsentRejectAll = () => {
    if (!isCMPReady) return;
    window.__cmp('setConsent', 0);
  };
  const openConsentBanner = showDetails => {
    if (!isCMPReady) return;
    try {
      var _window$__cmp5, _window5;
      const data = (_window$__cmp5 = (_window5 = window).__cmp) === null || _window$__cmp5 === void 0 ? void 0 : _window$__cmp5.call(_window5, 'showScreen');
      if (data) {
        setCookieModalOpen(true);
      } else {
        setCookieModalOpen(false);
      }
    } catch {}
    setIsDetailsOpen(showDetails);
  };
  const eventTracking = (eventName, eventData) => {
    if (_utils.isServer) return;
    try {
      sendEvents(_objectSpread({
        event: eventName
      }, eventData));
    } catch (e) {}
  };
  return /*#__PURE__*/_react.default.createElement(CookieContext.Provider, {
    value: {
      setCookiesAllowed,
      openConsentBanner,
      isModalOpen: isCookieModalOpen,
      showDetails: isDetailsOpen,
      eventTracking,
      getCookieAllowedById,
      isCMPReady
    }
  }, children);
};
exports.CookieProvider = CookieProvider;